/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Assessment } from './Assessment';
/**
 * 
 * @export
 * @interface ActivityDefinition
 */
export interface ActivityDefinition {
    /**
     * 
     * @type {string}
     * @memberof ActivityDefinition
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityDefinition
     */
    description?: string | null;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof ActivityDefinition
     */
    assessments?: Array<Assessment> | null;
}

/**
 * Check if a given object implements the ActivityDefinition interface.
 */
export function instanceOfActivityDefinition(value: object): value is ActivityDefinition {
    return true;
}

export function ActivityDefinitionFromJSON(json: any): ActivityDefinition {
    return ActivityDefinitionFromJSONTyped(json, false);
}

export function ActivityDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityDefinition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'assessments': json['assessments'] == null ? undefined : ((json['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentFromJSON)),
    };
}

export function ActivityDefinitionToJSON(json: any): ActivityDefinition {
    return ActivityDefinitionToJSONTyped(json, false);
}

export function ActivityDefinitionToJSONTyped(value?: ActivityDefinition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'assessments': value['assessments'] == null ? undefined : ((value['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentToJSON)),
    };
}

